"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutdatedSnackbar = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importStar(require("react"));
var Close_1 = __importDefault(require("@material-ui/icons/Close"));
var hooks_1 = require("../hooks");
var useStyles = (0, core_1.makeStyles)(function () {
    return (0, core_1.createStyles)({
        root: {
            flexWrap: 'nowrap'
        }
    });
});
var OutdatedSnackbar = function (_a) {
    var outdated = _a.outdated, message = _a.message, actionText = _a.actionText, autoHideDuration = _a.autoHideDuration, action = _a.action, onClose = _a.onClose;
    var classes = useStyles();
    var _b = (0, react_1.useState)(false), showSnackbar = _b[0], setShowSnackbar = _b[1];
    var previousOutdated = (0, hooks_1.usePrevious)(outdated);
    var handleClose = (0, react_1.useCallback)(function () {
        setShowSnackbar(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, []);
    (0, react_1.useEffect)(function () {
        if (!previousOutdated && outdated) {
            setShowSnackbar(true);
        }
        else if (previousOutdated && !outdated) {
            setShowSnackbar(false);
        }
    }, [previousOutdated, outdated]);
    return (react_1.default.createElement(core_1.Snackbar, { open: showSnackbar, autoHideDuration: autoHideDuration !== null && autoHideDuration !== void 0 ? autoHideDuration : 6000, onClose: handleClose, ContentProps: { classes: classes }, message: react_1.default.createElement("span", { style: { fontSize: 16, whiteSpace: 'nowrap' } }, message !== null && message !== void 0 ? message : 'Some items in the overview contain changes, press reload to show these changes'), action: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Button, { variant: 'contained', color: 'primary', size: 'small', onClick: action }, actionText !== null && actionText !== void 0 ? actionText : 'RELOAD'),
            react_1.default.createElement(core_1.IconButton, { size: 'small', "aria-label": 'close', color: 'inherit', onClick: handleClose },
                react_1.default.createElement(Close_1.default, { fontSize: 'small' }))) }));
};
exports.OutdatedSnackbar = OutdatedSnackbar;
//# sourceMappingURL=OutdatedSnackbar.js.map